import React from 'react'
import {browserHistory} from 'react-router'
import techAlliance from '../../../static/techAlliance.png'
import Image from '../../../basic/image'
import Amortizatory from '../../../static/amortizatory.png'
import Sceplenie from '../../../static/sceplenie.png'
import Podshipnik from '../../../static/podshipnik.png'
import Termostat from '../../../static/termostat.png'
import Krestovina from '../../../static/krestovina.png'
import Shrus from '../../../static/CV_joint_Finwhale.png'
import Button from "../../../basic/button";
import styled from 'styled-components'
import getImgUrl from "../../../getImgUrl";
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';


const ItemStyled = styled.div`
  background: rgb(235, 235, 235);
  cursor: pointer;
  &:hover {
    background: rgb(235, 235, 235);
  }
`

export default function c ({ style }) {
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <div style={{textAlign: 'center', width: '80%', ...style}}>
            <div
              style={{
                width: '70%',
                display: 'inline-block',
                textAlign: 'left',
              }}
            >
              <div
                style={{
                  fontSize: 24,
                  fontWeight: 800,
                  marginTop: 20,
                  marginBottom: 20,
                  position: 'relative',
                }}
              >
                <TranslateText id="main__production-title" place="left" />
              </div>
              <div
                style={{
                  marginTop: 10,
                  fontSize: 18,
                  position: 'relative',
                }}
              >
                <TranslateText id={'main__tecdoc'} place="left" />
              </div>
              <div
                style={{
                  marginTop: 10,
                  color: '#5C707B',
                  position: 'relative',
                }}
              >
                <TranslateText id={'main__production_odobreno'} place="left" />
              </div>
            </div>
            <Image
              src={techAlliance}
              containerStyle={{
                width: '30%',
              }}
              width={'100%'}
            />
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                marginTop: 25,
              }}
            >
              <AmortItem
                src={Amortizatory}
                width={'50%'}
                caption={
                  <TranslateText
                    id="nav_products__absorbers"
                    place="bottom"
                  />
                }
                href={'/shocks'}
              />
              <Item
                src={Sceplenie}
                width={'25%'}
                caption={
                  <TranslateText
                    id="nav_products__clutch"
                    place="bottom"
                  />
                }
                href={'/clutch'}
              />
              <Item
                src={getImgUrl(`/media/static/cats/kolodki.png`)}
                width={'25%'}
                caption={
                  <TranslateText
                    id="nav_products__brake_pads"
                    place="bottom"
                  />
                }
                href={'/brake-pads'}
              />
              <Item
                src={Podshipnik}
                width={'25%'}
                caption={
                  <TranslateText
                    id="nav_products__wheel_bearings"
                    place="bottom"
                  />
                }
                href={'/bearing'}
              />
              <Item
                src={Termostat}
                width={'25%'}
                caption={
                  <TranslateText
                    id="nav_products__termostats"
                    place="bottom"
                  />
                }
                href={'/thermostat'}
              />
              {currentLanguage == 'ua' ?
                <Item
                  src={getImgUrl(`/media/static/cats/pompa.png`)}
                  width='25%'
                  caption={<TranslateText id="nav_products__cooling_system_pumps" place="bottom" />}
                  href='/water-pump'
                /> :
                <Item
                  src={Krestovina}
                  width={'25%'}
                  caption={
                    <TranslateText
                      id="nav_products__crossews"
                      place="bottom"
                    />
                  }
                  href={'/universal-joint'}
                />
              }
              <Item
                src={Shrus}
                width={'25%'}
                caption={
                  <TranslateText
                    id="nav_products__shrus"
                    place="bottom"
                  />
                }
                href={'/cv-joint'}
              />
            </div>
            <TranslateText
              id="buttons__show-all-catalogue"
              place="bottom"
              style={{marginTop: 20, display: 'inline-block'}}
              render={text => {
                return (
                  <Button
                    onClick={() => {
                      browserHistory.push('/production')
                    }}
                  >
                    {text}
                  </Button>
                );
              }}
            />
          </div>
        </div>
      }}
    </CurrentLanguageContext.Consumer>
  )
}

function Item({src, width, caption, href}) {
  return (
    <ItemStyled
      style={{
        border: '1px solid white',
        width: width,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 250,
        flexDirection: 'column',
        fontWeight: 800,
        zIndex: 10,
        padding: '20px 10px',
      }}
      onClick={() => {
        browserHistory.push(href)
      }}
    >
      <Image
        src={src}
        style={{
          maxWidth: '70%',
          maxHeight: '100%',
        }}
        containerStyle={{
          height: '80%',
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
      <div
        style={{
          display: 'inline-block',
          textAlign: 'center',
          paddingLeft: 25,
          paddingRight: 25,
          fontSize: 18,
        }}
      >
        {caption}
      </div>
    </ItemStyled>
  )
}

function AmortItem({src, width, caption, href}) {
  return (
    <ItemStyled
      style={{
        border: '1px solid white',
        width: width,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 250,
        flexDirection: 'row',
        minWidth: 250,
        paddingRight: 50,
        cursor: 'pointer',
        fontWeight: 800,
        zIndex: 10,
      }}
      onClick={() => {
        browserHistory.push(href)
      }}
    >
      <Image
        src={src}
        style={{
          minWidth: 100,
          maxWidth: '70%',
        }}
      />
      <div
        style={{
          flexGrow: 1,
          display: 'inline-block',
          textAlign: 'center',
          fontSize: 18,
        }}
      >
        {caption}
      </div>
    </ItemStyled>
  )
}



// WEBPACK FOOTER //
// ./src/finwhale/common/catalogue/Desktop.js